/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_ClearInputs */

const en_control_planner_clear = /** @type {(inputs: Control_Planner_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear group`)
};

const zh_control_planner_clear = /** @type {(inputs: Control_Planner_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除`)
};

/**
* | output |
* | --- |
* | "Clear group" |
*
* @param {Control_Planner_ClearInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_clear = /** @type {((inputs?: Control_Planner_ClearInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_ClearInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_clear(inputs)
	return zh_control_planner_clear(inputs)
});
export { control_planner_clear as "control.planner.clear" }